/**
 * GaugeGallery - Re-export from organized module structure
 * 
 * The gallery has been refactored into smaller, organized files:
 * - GaugeGallery/index.tsx - Main component
 * - GaugeGallery/types.ts - TypeScript interfaces
 * - GaugeGallery/presets.ts - Gauge presets and configurations
 * - GaugeGallery/styles.ts - Theme-aware styles
 * - GaugeGallery/utils.ts - Utility functions
 * - GaugeGallery/components/ - React components
 */
import GaugeGallery from './GaugeGallery/index';
export default GaugeGallery;
